module.exports = __webpack_public_path__ + "static/media/administration.494a6d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projects/granvillebands/administration.png
// module id = 168
// module chunks = 0